import { NavLink, useNavigate } from "react-router-dom";
import { useState, useRef } from "react";
import axios from "axios";
import JobZImage from "../../../../common/jobz-img";
import { useTranslation } from "react-i18next";
import { publicUser } from "../../../../../globals/route-names";
import { API_URL } from "../../../../../config";
import { toast } from "react-toastify";
import HCaptcha from "@hcaptcha/react-hcaptcha";

const RegisterPage = () => {
    const navigate = useNavigate();

    // State for form fields
    const { t } = useTranslation();
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [captchaToken, setCaptchaToken] = useState(null);

    const captchaRef = useRef(null);

    // Handle Registration
    const handleRegister = async (e) => {
        e.preventDefault();

        // Validate required fields
        if (!firstname || !lastname || !email || !password || !confirmPassword) {
            toast.error("Please fill in all fields.");
            return;
        }

        // Validate hCaptcha
        if (!captchaToken) {
            toast.error("Please complete the CAPTCHA to register.");
            return;
        }

        if (password !== confirmPassword) {
            toast.error("Passwords do not match.");
            return;
        }

        const userData = {
            firstName: firstname,
            lastName: lastname,
            email,
            password,
            confirmPassword,
        };

        try {
            const response = await axios.post(`${API_URL}/register`, userData);

            if (response.status === 201) {
                toast.success("Registration successful! Please log in.");

                setFirstname("");
                setLastname("");
                setEmail("");
                setPassword("");
                setConfirmPassword("");
                setCaptchaToken(null);
                captchaRef.current.resetCaptcha();

                navigate("/login");
            }
        } catch (err) {
            const message = err.response?.data?.message || "Registration failed";
            toast.error(message);
        }
    };

    return (
        <div className="section-full site-bg-white">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-8 col-lg-6 col-md-5 twm-log-reg-media-wrap">
                        <div className="twm-log-reg-media">
                            <JobZImage src="images/login-bg.png" alt="" />
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-6 col-md-7">
                        <div className="twm-log-reg-form-wrap">
                            <div className="twm-log-reg-logo-head">
                                <NavLink to={publicUser.INITIAL}>
                                    <JobZImage src="/images/skins-logo/logo-skin-6.png" alt="" className="logo" />
                                </NavLink>
                            </div>
                            <div className="twm-log-reg-inner">
                                <div className="twm-log-reg-head">
                                    <span className="log-reg-form-title">{t("Register")}</span>
                                </div>
                                <div className="twm-tabs-style-2">
                                    <div className="tab-content">
                                        <form onSubmit={handleRegister} className="tab-pane fade show active">
                                            <div className="form-group mb-3">
                                                <label style={{ display: 'block', textAlign: 'left', marginBottom: '4px' }} htmlFor="FirstnameInput">{t("Firstname")} :</label>
                                                <input
                                                    id="FirstnameInput"
                                                    name="Firstname"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={`${t("Firstname")}*`}
                                                    value={firstname}
                                                    onChange={(e) => setFirstname(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group mb-3">
                                                <label style={{ display: 'block', textAlign: 'left', marginBottom: '4px' }} htmlFor="LastnameInput">{t("Lastname")} :</label>
                                                <input
                                                    id="LastnameInput"
                                                    name="Lastname"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={`${t("Lastname")}*`}
                                                    value={lastname}
                                                    onChange={(e) => setLastname(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group mb-3">
                                                <label style={{ display: 'block', textAlign: 'left', marginBottom: '4px' }} htmlFor="emailInput">{t("Email")} :</label>
                                                <input
                                                    id="emailInput"
                                                    name="Email"
                                                    type="email"
                                                    className="form-control"
                                                    placeholder={`${t("Email")}*"`}
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group mb-3">
                                                <label style={{ display: 'block', textAlign: 'left', marginBottom: '4px' }} htmlFor="passwordInput">{t("Password")} :</label>
                                                <input
                                                    id="passwordInput"
                                                    name="Password"
                                                    type="password"
                                                    className="form-control"
                                                    placeholder={`${t("Password")}*`}
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group mb-3">
                                                <label style={{ display: 'block', textAlign: 'left', marginBottom: '4px' }} htmlFor="passwordInput">{t("Confirm Password")} :</label>
                                                <input
                                                    id="passwordInput"
                                                    name="Confirm Password"
                                                    type="password"
                                                    className="form-control"
                                                    placeholder={`${t("Confirm Password")}*`}
                                                    value={confirmPassword}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group mb-3">
                                                <HCaptcha
                                                    sitekey={process.env.REACT_APP_HCAPTCHA_SITE_KEY}
                                                    onVerify={(token) => setCaptchaToken(token)}
                                                    ref={captchaRef}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <button type="submit" className="site-button">{t("Register")}</button>
                                            </div>

                                            <p>
                                                {t("I have already account go to")}
                                                <NavLink style={{ textDecoration: 'underline', marginLeft: '5px' }} to={publicUser.pages.LOGIN}>
                                                    {t("login")}
                                                </NavLink>
                                            </p>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegisterPage;
